
// src/lang.js
export const translations = {
    bm: {
      heroTitle: 'Dengan FlyHigh, Anak Anda <br /Terbang Tinggi Menggapai Impian!',
      startNow: 'Mulakan Sekarang',
      subHero: 'Platform pembelajaran dalam talian yang menawarkan kursus berbayar<br />' +
         'Berkualiti tinggi dalam pelbagai subjek untuk membantu anda belajar, berkembang, dan mencapai matlamat.',
      //categories
      whyUs: 'KENAPA KAMI?',
      whyUsSub: 'Apa yang dikatakan oleh pelajar lain yang telah menjadi profesional tentang kami setelah belajar dengan kami dan mencapai matlamat mereka',
      features: [{
        icon: require('@/assets/img/flyhigh/chalk.png'),
        title: "Guru Berpengalaman",
        description: "Panduan pakar yang diberikan melalui pengetahuan dan pengalaman guru yang sangat berkelayakan, memastikan pemahaman yang mendalam dan menyeluruh tentang setiap subjek."
    },
    {
        icon: require('@/assets/img/flyhigh/tag.png'),
        title: "Harga Berpatutan",
        description: "Kualiti sebenar tidak ditentukan oleh harga yang tinggi; adalah mungkin untuk mengalami kerajinan yang luar biasa, prestasi yang boleh dipercayai, dan perkhidmatan yang cemerlang tanpa kos yang berlebihan, menjadikan kecemerlangan dapat diakses oleh semua tanpa kompromi."
    },
    {
        icon: require('@/assets/img/flyhigh/chat.png'),
        title: "Rekod Prestasi Terbukti",
        description: "Hasil yang dihasilkan oleh platform kami bercakap untuk dirinya sendiri, jelas menunjukkan impak transformasi yang dibawa oleh kursus kami kepada pelajar. Dari peningkatan pengekalan pengetahuan hingga aplikasi kemahiran dunia nyata, hasil yang nyata mencerminkan kepakaran, dedikasi, dan pendekatan inovatif yang kami bawa ke dalam pendidikan."
    },
    {
        icon: require('@/assets/img/flyhigh/online.png'),
        title: "Dalam Talian & Secara Bersemuka",
        description: "Kami menawarkan pilihan pembelajaran yang fleksibel yang disesuaikan dengan keperluan anda—sama ada anda lebih suka kemudahan kelas dalam talian atau penglibatan sesi secara peribadi. Model hibrid kami memastikan anda menerima pendidikan berkualiti tinggi yang sama dalam format yang paling sesuai untuk anda."
    },
    {
        icon: require('@/assets/img/flyhigh/quality.png'),
        title: "Kandungan Berkualiti",
        description: "Dengan komitmen kami terhadap kecemerlangan, kami menjamin kandungan yang berkualiti tinggi yang telah diteliti dengan teliti, dicipta oleh pakar, dan sentiasa dikemas kini untuk memberikan nilai tertinggi dan memastikan anda mempunyai akses kepada bahan terbaik yang tersedia."
    },
    {
        icon: require('@/assets/img/flyhigh/support.png'),
        title: "Sokongan Aktif",
        description: "Tidak kira masa atau situasi, kami sentiasa di sini untuk membantu anda, menawarkan sokongan yang cepat dan boleh dipercayai untuk memastikan keperluan anda dipenuhi dan anda mempunyai pengalaman yang lancar dengan kami di setiap langkah."
    }
]
    },
    en: {
      heroTitle: 'With FlyHigh, Your Child <br / Soars to Reach Their Dreams!',
      startNow: 'Start Now',
      subHero: 'Online learning platform that offers high-quality <br /> paid courses in various subjects to help you learn, grow, and achieve goals.',
      // categories
      whyUs: 'WHY US?',
      whyUsSub: 'What other students turned professionals have to say about us after learning with us and reaching their goals.',
      features: [{
        icon: require('@/assets/img/flyhigh/chalk.png'),
        title: "Experienced Teachers",
        description: "Expert guidance provided through the knowledge and experience of highly qualified teachers, ensuring a deep and comprehensive understanding of every subject."
    },
    {
        icon: require('@/assets/img/flyhigh/tag.png'),
        title: "Affordable Price",
        description: "Kualiti sebenar tidak ditentukan oleh harga yang tinggi; adalah mungkin untuk mengalami kerajinan yang luar biasa, prestasi yang boleh dipercayai, dan perkhidmatan yang cemerlang tanpa kos yang berlebihan, menjadikan kecemerlangan dapat diakses oleh semua tanpa kompromi."
    },
    {
        icon: require('@/assets/img/flyhigh/chat.png'),
        title: "Proven Track Record",
        description: "The results our platform delivers speak for themselves, clearly showcasing the transformative impact our courses have on learners. From enhanced knowledge retention to real-world skill application, the tangible results reflect the expertise, dedication, and innovative approach we bring to education."
    },
    {
        icon: require('@/assets/img/flyhigh/online.png'),
        title: "Online & Face-to-Face",
        description: "We offer flexible learning options tailored to your needs—whether you prefer the convenience of online classes or the engagement of in-person sessions. Our hybrid model ensures you receive the same high-quality education in the format that suits you best."
    },
    {
        icon: require('@/assets/img/flyhigh/quality.png'),
        title: "Quality Content",
        description: "With our commitment to excellence, we guarantee top-notch content that is thoroughly researched, expertly created, and consistently updated to deliver the highest value and ensure you have access to the best materials available."
    },
    {
        icon: require('@/assets/img/flyhigh/support.png'),
        title: "Active Support",
        description: "No matter the time or situation, we are always here to assist you, offering prompt and reliable support to ensure that your needs are met and that you have a seamless experience with us every step of the way."
    }
]
    }
  }

  